import React, {Fragment} from 'react';
import {Button, Glyphicon, PageHeader, Panel, PanelGroup, ToggleButton, ToggleButtonGroup} from 'react-bootstrap';
import ProgramsPanel from '../program/ProgramsPanel';
import {Link} from 'react-router-dom';
import './CompanyPage.css';
import PrimaryAimType from '../utils/PrimaryAimType';
import CompanyTreeMapByProgram from './CompanyTreeMapByProgram';
import NotFoundPage from '../NotFoundPage';
import ErrorComponent from '../ErrorComponent';
import {connect} from 'react-redux';
import {clearErrors, getCompanies, getPrograms, getTeams} from '../utils/actions';
import EngagementsPanel from '../engagement/EngagementsPanel';

class CompanyPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      company: null,
      programs: [],
      teams: [],
      error: null,
      loading: true,
      toggleMapView: false,
      notFound: false,
    };

    this.primaryAim=this.primaryAim.bind(this);
  }

  componentDidMount() {
    this.fetchCompany();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.company && this.props.companies.data[this.props.match.params.companyId]) {
      this.setState({ company: this.props.companies.data[this.props.match.params.companyId]});
    }
  }

  fetchCompany = () => {
    const companyId = this.props.match.params.companyId;

    this.props.fetchCompanies({id: companyId});
    this.props.fetchPrograms({companyId});
    this.props.fetchTeams({companyId});
  };

  isLoading = () => {
    return this.props.companies.isLoading
      || this.props.programs.isLoading
      || this.props.teams.isLoading;
  };

  primaryAim() {
    switch (this.state.company.primary_aim_id) {
      case PrimaryAimType.PRODUCTIVITY:
        return 'Productivity';
      case PrimaryAimType.QUALITY:
        return 'Quality';
      case PrimaryAimType.PREDICTABILITY:
        return 'Predictability';
      case PrimaryAimType.ADAPTABILITY:
        return 'Adaptability';
      default:
        return null;
    }
  }

  render() {
    if (this.state.notFound) return <NotFoundPage/>;
    if (this.isLoading() || !this.state.company) return <p>Loading...</p>;
    return (
      <div>
        <ErrorComponent error={this.props.errors}/>
        <PageHeader data-cy="company-header" align="center">{this.state.company.name}</PageHeader>
        <div className='flex-row-spaced'>
          <ToggleButtonGroup
            type='radio'
            name='mapView'
            value={+this.state.toggleMapView}
            onChange={(value) => { this.setState({ toggleMapView: !!value }); }}>
            <ToggleButton value={0}><Glyphicon glyph='list'/></ToggleButton>
            <ToggleButton value={1}><Glyphicon glyph='picture'/></ToggleButton>
          </ToggleButtonGroup>
        </div>

        {
          Object.values(this.props.teams.data).length > 0 && this.state.toggleMapView &&
          <Fragment>
            <br/>
            <p className='ta-center'>Colors represent overall score for each team. &nbsp;Clicking on a team will open the team dashboard page.</p>
            <CompanyTreeMapByProgram
              company={this.state.company}
              programs={Object.values(this.props.programs.data)}
              teams={Object.values(this.props.teams.data)}
              onError={(e) => this.setState({error: e.errors})}
            />
          </Fragment>

        }
        <PanelGroup id="company-panel-group">
          {
            !this.state.toggleMapView &&
            <Fragment>
              <ProgramsPanel
                company_id={this.props.match.params.companyId}
                programs={Object.values(this.props.programs.data)}
                teams={Object.values(this.props.teams.data)}
              />
              <EngagementsPanel company_id={parseInt(this.props.match.params.companyId, 10)} onError={(e) => this.setState({error: e.errors})}/>
            </Fragment>
          }

          <Panel>
            <Panel.Heading>
              <Panel.Title componentClass="h3">Details</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div className='details-container'>
                <h4>Primary Aim: &nbsp;&nbsp;{this.primaryAim() ? this.primaryAim() : 'None'}</h4>
                <Link to={`/companies/${this.props.match.params.companyId}/contacts`}>
                  <Button data-cy="contacts-link">View Contacts</Button>
                </Link>
              </div>
            </Panel.Body>
          </Panel>
        </PanelGroup>
      </div>
    );
  }
}

const mapStateToProps = state => {
  if (!state) {
    return { companies: {}, programs: {}, teams: {}, errors: {} };
  }

  return { companies: state.companies, programs: state.programs, teams: state.teams, errors: state.errors };
};

const mapDispatchToProps = dispatch => ({
  fetchCompanies: (query) => dispatch(getCompanies(query)),
  fetchPrograms: (query) => dispatch(getPrograms(query)),
  fetchTeams: (query) => dispatch(getTeams(query)),
  clearError: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyPage);


// WEBPACK FOOTER //
// ./src/components/company/CompanyPage.js